import { ScreenBase } from "@frui.ts/screens";
import { action, observable } from "mobx";
import type LocalizationService from "services/localizationService";

export default class AdHocReportsConfirmationViewModel extends ScreenBase {
  @observable isOpened = false;
  private onResult: (value: { confirmed: boolean; generate: boolean }) => void;

  readonly title: string;
  readonly message: string;
  readonly emailAddressChanged: boolean;
  readonly isBulkChargeOrder: boolean;

  @observable sendConfirmationForSingleChargeOnly = true;

  constructor(public localizationService: LocalizationService) {
    super();
  }

  get canBeNavigationActiveScreen() {
    return false;
  }

  @action.bound
  public showConfirmation() {
    this.isOpened = true;
    return new Promise<{ confirmed: boolean; generate: boolean }>(resolve => {
      this.onResult = resolve;
    });
  }

  @action.bound
  confirm() {
    this.isOpened = false;
    this.onResult({ confirmed: true, generate: false });
  }

  @action.bound callback() {
    this.isOpened = false;
    this.onResult({ confirmed: true, generate: true });
  }

  @action.bound
  cancel() {
    this.isOpened = false;
    this.onResult({ confirmed: false, generate: false });
  }
}
